export const formatMoney = (number: number, decimal = 0): string => {
  number = number / 100;

  return number.toLocaleString('cs-CZ', { style: 'currency', currency: 'CZK', maximumFractionDigits: decimal });
};

export default {
  format: formatMoney,
};
